/**
 * The Analytics boards the signed-in player can open, shared by every
 * Dashboard widget on the page.
 *
 * Three cards pinned to three boards would otherwise fire three identical
 * GET /api/dashboard calls on every home-page load, so the fetch is cached
 * and de-duplicated here. The TTL is short: it exists to collapse a burst of
 * mounts, not to keep serving a stale answer after an admin revokes access.
 */
import { GET_DASHBOARDS } from "../../../api/dashboard";

const TTL_MS = 30 * 1000;

let cache = null; // { at, rows }
let inflight = null;

/** Forget the cached list, so the next read goes back to the server. */
export const clearDashboardAccessCache = () => {
  cache = null;
  inflight = null;
};

export const fetchReadableDashboards = async () => {
  if (cache && Date.now() - cache.at < TTL_MS) return cache.rows;
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const res = await GET_DASHBOARDS();
      const rows = Array.isArray(res?.data) ? res.data : [];
      cache = { at: Date.now(), rows };
      return rows;
    } catch (err) {
      /* A failed read must not be mistaken for "no access" — leave the cache
         alone so the next mount retries rather than hiding every card. */
      return cache ? cache.rows : null;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
};
